export function handleAdmissionPaymentConfirmedEvent(notificationPayload) {
  window.dispatchEvent(
    new CustomEvent('sseAdmissionPaymentConfirmed', {
      detail: notificationPayload,
    }),
  );
}
